import script from "./ClassAnalysis.vue?vue&type=script&setup=true&lang=ts"
export * from "./ClassAnalysis.vue?vue&type=script&setup=true&lang=ts"

import "./ClassAnalysis.vue?vue&type=style&index=0&id=6527157a&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6527157a"]])

export default __exports__